import React from 'react'
import { Avatar } from '@material-ui/core'
import clsx from 'clsx'
import { ICONES_SISTEMA } from 'globals/icones'
import useStyles from './styles'

/**
 * 👤 ObjetoAvatar: A Fonte Única de Verdade para Avatares de Objetos no SIGEP
 * 
 * Este componente centraliza a renderização e estilização de avatares.
 * Se amanhã você quiser trocar de redondo para quadrado com fundo vermelho,
 * basta alterar o stylesheet local deste componente ou as suas props padrão! 🛡️🛸🚀
 * 
 * Props:
 * @param {string} tipo - Chave do objeto registrado no ICONES_SISTEMA (ex: 'VESTIGIO', 'LOCAL')
 * @param {string} [className] - Sobrescrita de classe CSS opcional
 */
export const ObjetoAvatar = ({ tipo, className, children, ...rest }) => {
  const classes = useStyles()
  const IconComponent = tipo ? ICONES_SISTEMA[tipo] : null

  return (
    <Avatar
      className={clsx(classes.avatar, className)}
      {...rest}

    >
      {IconComponent ? <IconComponent /> : children}
    </Avatar>
  )
}

export default ObjetoAvatar
